module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-page-box"
  }, [_c('div', {
    staticClass: "back-box",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fas fa-chevron-left fa-fw"
  }), _vm._v("\n    BACK\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "rev-head"
  }, [_vm._v("Review and Book")]), _vm._v(" "), _c('div', {
    staticClass: "rev-page"
  }, [_c('div', {
    staticClass: "rev-hero"
  }, [_c('img', {
    attrs: {
      "src": _vm.selected.HotelPicture
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-content"
  }, [_c('div', {
    staticClass: "hero-badge"
  }, [_vm._v("Hotel")]), _vm._v(" "), _c('div', {
    staticClass: "hero-title"
  }, [_vm._v(_vm._s(_vm.selected.HotelName))]), _vm._v(" "), _c('div', {
    staticClass: "hero-meta"
  }, [(_vm.selected.HotelAddress) ? _c('span', [_c('i', {
    staticClass: "fas fa-map-marker-alt fa-fw"
  }), _vm._v("\n            " + _vm._s(_vm.selected.HotelAddress) + "\n          ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "info-bar"
  }, [(_vm.view.first_room_details.room_name) ? _c('div', {
    staticClass: "info-card"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('label', [_vm._v("Room")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.view.first_room_details.room_name))])])]) : _vm._e(), _vm._v(" "), (_vm.view.StarRating) ? _c('div', {
    staticClass: "info-card"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('label', [_vm._v("Rating")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.view.StarRating))])])]) : _vm._e(), _vm._v(" "), (_vm.view.CheckInTime) ? _c('div', {
    staticClass: "info-card"
  }, [_vm._m(2), _vm._v(" "), _c('div', [_c('label', [_vm._v("Check In"), (_vm.view.CheckOutTime) ? _c('span', [_vm._v(" / Out")]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v("\n            " + _vm._s(_vm.view.CheckInTime) + "\n            "), (_vm.view.CheckOutTime) ? _c('span', [_vm._v(" / " + _vm._s(_vm.view.CheckOutTime))]) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "rev-two-col"
  }, [_c('div', {
    staticClass: "rev-two-main"
  }, [_c('div', {
    staticClass: "section-box"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "description-text",
    domProps: {
      "innerHTML": _vm._s(_vm.view.Description)
    }
  })]), _vm._v(" "), (_vm.view.SpecialInstructions) ? _c('div', {
    staticClass: "section-box"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "description-text",
    domProps: {
      "innerHTML": _vm._s(_vm.view.SpecialInstructions)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.view.HotelFacilities && _vm.view.HotelFacilities.length) ? _c('div', {
    staticClass: "section-box"
  }, [_vm._m(5), _vm._v(" "), _vm._l((_vm.view.HotelFacilities), function(inc) {
    return _c('div', {
      staticClass: "description-text"
    }, [_c('i', {
      staticClass: "fas fa-check fa-fw"
    }), _vm._v("\n            " + _vm._s(inc) + "\n          ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-box"
  }, [_c('div', {
    staticClass: "sb-header"
  }, [_vm._m(6), _vm._v(" "), (_vm._token) ? _c('div', {
    staticClass: "sb-account"
  }, [_vm._v("\n              Welcome "), _c('b', [_vm._v(_vm._s(_vm.user.firstName))]), _vm._v("!\n              (Not "), _c('b', [_vm._v(_vm._s(_vm.user.firstName))]), _vm._v("? "), _c('a', {
    on: {
      "click": _vm.logout
    }
  }, [_c('b', [_vm._v("Logout")])]), _vm._v(")\n            ")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.paxForm.adult.slice(0, 1)), function(pax, p) {
    return _c('div', {
      key: p,
      staticClass: "pax-form"
    }, [_c('div', {
      staticClass: "d-flex pax-fields align-start"
    }, [_c('div', {
      class: ['pax-field', {
        'has-error': _vm.paxErrorFields.adult.indexOf(("title" + p)) > -1
      }]
    }, [_c('div', {
      staticClass: "pax-field-label"
    }, [_vm._v("Title")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pax[("title" + p)]),
        expression: "pax[`title${p}`]"
      }],
      staticClass: "pax-title no-outline",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          var $$exp = pax,
            $$idx = "title" + p;
          if (!Array.isArray($$exp)) {
            pax[("title" + p)] = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
          } else {
            $$exp.splice($$idx, 1, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("--")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Mr"
      }
    }, [_vm._v("Mr.")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Ms"
      }
    }, [_vm._v("Ms.")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Mrs"
      }
    }, [_vm._v("Mrs.")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Miss"
      }
    }, [_vm._v("Miss")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Mstr"
      }
    }, [_vm._v("Mstr")])])]), _vm._v(" "), _c('div', {
      class: ['pax-field fw', {
        'has-error': _vm.paxErrorFields.adult.indexOf(("firstName" + p)) > -1
      }]
    }, [_vm._m(7, true), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pax[("firstName" + p)]),
        expression: "pax[`firstName${p}`]"
      }],
      staticClass: "no-outline",
      attrs: {
        "type": "text",
        "placeholder": "First Name"
      },
      domProps: {
        "value": (pax[("firstName" + p)])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = pax,
            $$idx = "firstName" + p;
          if (!Array.isArray($$exp)) {
            pax[("firstName" + p)] = $event.target.value
          } else {
            $$exp.splice($$idx, 1, $event.target.value)
          }
        }
      }
    })]), _vm._v(" "), _c('div', {
      class: ['pax-field fw', {
        'has-error': _vm.paxErrorFields.adult.indexOf(("lastName" + p)) > -1
      }]
    }, [_vm._m(8, true), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pax[("lastName" + p)]),
        expression: "pax[`lastName${p}`]"
      }],
      staticClass: "no-outline",
      attrs: {
        "type": "text",
        "placeholder": "Last Name"
      },
      domProps: {
        "value": (pax[("lastName" + p)])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = pax,
            $$idx = "lastName" + p;
          if (!Array.isArray($$exp)) {
            pax[("lastName" + p)] = $event.target.value
          } else {
            $$exp.splice($$idx, 1, $event.target.value)
          }
        }
      }
    })])]), _vm._v(" "), (p === 0) ? _c('div', {
      class: ['pax-field fw', {
        'has-error': _vm.paxErrorFields.adult.indexOf(("email" + p)) > -1
      }],
      staticStyle: {
        "margin-bottom": "20px"
      }
    }, [_vm._m(9, true), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pax[("email" + p)]),
        expression: "pax[`email${p}`]"
      }],
      staticClass: "no-outline",
      attrs: {
        "type": "text",
        "placeholder": "Email",
        "disabled": ""
      },
      domProps: {
        "value": (pax[("email" + p)])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = pax,
            $$idx = "email" + p;
          if (!Array.isArray($$exp)) {
            pax[("email" + p)] = $event.target.value
          } else {
            $$exp.splice($$idx, 1, $event.target.value)
          }
        }
      }
    })]) : _vm._e(), _vm._v(" "), (p === 0) ? _c('div', {
      staticClass: "pax-field fw",
      staticStyle: {
        "margin-bottom": "20px"
      }
    }, [_vm._m(10, true), _vm._v(" "), _c('mobile-input', {
      staticClass: "no-outline",
      attrs: {
        "needVerification": false,
        "mobile": pax[("mobile" + p)],
        "dialCode": pax[("countryCode" + p)],
        "forPax": true,
        "uniqID": 'mobile2',
        "forceDisabled": true,
        "required": true,
        "hasError": _vm.paxErrorFields.adult.indexOf(("mobile" + p)) > -1
      },
      on: {
        "updateMobile": function($event) {
          pax[("countryCode" + p)] = $event.countryCode;
          pax[("mobile" + p)] = $event.mobile;
          _vm.highlightCheck()
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      class: ['pax-field fw', {
        'has-error': _vm.paxErrorFields.adult.indexOf(("age" + p)) > -1
      }]
    }, [_vm._m(11, true), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pax[("age" + p)]),
        expression: "pax[`age${p}`]"
      }],
      staticClass: "no-outline",
      attrs: {
        "type": "text",
        "placeholder": "Age"
      },
      domProps: {
        "value": (pax[("age" + p)])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = pax,
            $$idx = "age" + p;
          if (!Array.isArray($$exp)) {
            pax[("age" + p)] = $event.target.value
          } else {
            $$exp.splice($$idx, 1, $event.target.value)
          }
        }
      }
    })])])
  })], 2), _vm._v(" "), _c('payment-form', {
    ref: "paymentForm",
    staticClass: "payment-form-box",
    on: {
      "done": _vm.paymentDone,
      "changeCard": _vm.changeCard
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "price-section"
  }, [_c('div', {
    staticClass: "price-label"
  }, [_vm._v("Total Price")]), _vm._v(" "), _c('div', {
    staticClass: "price-value"
  }, [_vm._v("\n            " + _vm._s(_vm.currencySymbol[_vm.currency.code]) + "\n            "), _vm._v("\n            " + _vm._s(_vm.finalPrice()) + " \n            "), _c('span', [_vm._v(_vm._s(_vm.currency.code))])]), _vm._v(" "), _c('div', {
    staticClass: "price-note"
  }, [_vm._v("Total for " + _vm._s(_vm.filters.travellers.total) + " traveler • Taxes included")]), _vm._v(" "), _c('button', {
    staticClass: "km-btn",
    on: {
      "click": _vm.initBook
    }
  }, [_vm._v("Book Now")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "rev-two-side"
  }, [(_vm.blockData.HotelRoomsDetails && _vm.blockData.HotelRoomsDetails.length && _vm.blockData.HotelRoomsDetails[0].CancellationPolicies.length) ? _c('div', {
    staticClass: "side-card"
  }, [_vm._m(12), _vm._v(" "), _vm._l((_vm.blockData.HotelRoomsDetails), function(room, i) {
    return _c('div', [(_vm.blockData.HotelRoomsDetails.length > 1) ? _c('div', {
      staticClass: "room-no"
    }, [_vm._v("Room #" + _vm._s(i + 1))]) : _vm._e(), _vm._v(" "), _vm._l((room.CancellationPolicies), function(cxl) {
      return _c('div', {
        staticClass: "c-row"
      }, [_c('span', {
        staticClass: "c-date"
      }, [_vm._v(_vm._s(_vm.cxlDate(cxl)))]), _vm._v(" "), _c('span', {
        class: ['c-fee', cxl.Charge ? 'paid' : 'free']
      }, [_vm._v(_vm._s(_vm.cxlFee(cxl)))])])
    })], 2)
  })], 2) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-icon"
  }, [_c('i', {
    staticClass: "fas fa-bed fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-icon"
  }, [_c('i', {
    staticClass: "fas fa-star fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-icon"
  }, [_c('i', {
    staticClass: "far fa-calendar fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sb-header"
  }, [_c('div', {
    staticClass: "sb-icon"
  }, [_c('i', {
    staticClass: "fas fa-info-circle fa-fw"
  })]), _vm._v(" "), _c('label', [_vm._v("About This Hotel")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sb-header"
  }, [_c('div', {
    staticClass: "sb-icon"
  }, [_c('i', {
    staticClass: "fas fa-info-circle fa-fw"
  })]), _vm._v(" "), _c('label', [_vm._v("Special Instruction")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sb-header"
  }, [_c('div', {
    staticClass: "sb-icon"
  }, [_c('i', {
    staticClass: "fas fa-info-circle fa-fw"
  })]), _vm._v(" "), _c('label', [_vm._v("Facilities")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sb-label"
  }, [_c('div', {
    staticClass: "sb-icon"
  }, [_c('i', {
    staticClass: "fas fa-user fa-fw"
  })]), _vm._v(" "), _c('label', [_vm._v("Customer Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pax-field-label"
  }, [_vm._v("First name"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pax-field-label"
  }, [_vm._v("Last name"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pax-field-label"
  }, [_vm._v("Email address"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pax-field-label"
  }, [_vm._v("Mobile number"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pax-field-label"
  }, [_vm._v("Age"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "side-label"
  }, [_c('i', {
    staticClass: "far fa-check-circle fa-fw"
  }), _vm._v("\n            Cancellation Policy\n          ")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3d2120eb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d2120eb","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/D2DHotel/review/index.vue
// module id = 2072
// module chunks = 0